import { render } from "./Button.vue?vue&type=template&id=80ccc21e&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=80ccc21e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-80ccc21e"

export default script